/**
 * Shared engine types.
 *
 * The physics simulation is 2D (playfield plane, x = lateral, y = "up-table").
 * The 3D renderer derives elevation (z) from scripted lane data on parts,
 * never from the physics world — see docs/PLAN.md §1.2.
 */

export type RenderMode = '3d' | '2d';

export type GamePhase =
  'boot' | 'menu' | 'playing' | 'paused' | 'ball-lost' | 'game-over' | 'enter-initials';

/** Fixed physics rate. High rate + CCD prevents ball tunneling through flippers. */
export const PHYSICS_HZ = 240;
export const PHYSICS_DT = 1 / PHYSICS_HZ;

/** World units for the canonical table ("Classic Zero"): 1 unit ≈ 1 cm of playfield. */
export const TABLE_WIDTH = 52;
export const TABLE_HEIGHT = 104;
export const BALL_RADIUS = 1.35;

/** Remappable game actions. Defaults set in settings store. */
export type GameAction =
  | 'flipper-left'
  | 'flipper-right'
  | 'plunger'
  | 'nudge-left'
  | 'nudge-right'
  | 'nudge-up'
  | 'pause'
  | 'mute'
  | 'toggle-view'
  | 'start';

export const DEFAULT_KEYMAP: Record<GameAction, string> = {
  'flipper-left': 'ShiftLeft',
  'flipper-right': 'ShiftRight',
  plunger: 'ArrowDown',
  'nudge-left': 'KeyA',
  'nudge-right': 'KeyD',
  'nudge-up': 'KeyW',
  pause: 'KeyP',
  mute: 'KeyM',
  'toggle-view': 'KeyV',
  start: 'Enter',
};

export const CONTROL_ALIASES: Partial<Record<GameAction, string[]>> = {
  'flipper-left': ['KeyZ', 'ArrowLeft'],
  'flipper-right': ['Slash', 'ArrowRight'],
  plunger: ['Space'],
  'nudge-left': ['KeyQ'],
  'nudge-right': ['KeyE'],
  'nudge-up': ['ArrowUp'],
};
